<script setup lang="ts">
import { router } from '@inertiajs/vue3'
import { ref } from 'vue'

import AppDatePicker from '@/components/AppDatePicker.vue'
import AppDialog from '@/components/AppDialog.vue'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { settleLoanApplicationPath } from '@/routes'

interface Props {
  applicationId: string
}

const props = defineProps<Props>()

const open = ref(false)
const processing = ref(false)
const settledDate = ref(new Date().toISOString().split('T')[0])

function openDialog() {
  settledDate.value = new Date().toISOString().split('T')[0]
  open.value = true
}

function submit() {
  if (processing.value) return
  processing.value = true
  router.post(
    settleLoanApplicationPath(props.applicationId),
    { settled_at: settledDate.value },
    {
      preserveScroll: true,
      onFinish: () => {
        processing.value = false
        open.value = false
      },
    },
  )
}
</script>

<template>
  <Button size="sm" variant="default" class="w-full" :disabled="processing" @click="openDialog">
    Settle Application
  </Button>

  <AppDialog
    v-model:open="open"
    title="Settle application?"
    description="Confirm the settlement date. This will mark the application as settled."
    :loading="processing"
    loading-message="Settling application…"
  >
    <div class="space-y-2">
      <Label for="settled-date">Settlement date</Label>
      <AppDatePicker id="settled-date" v-model="settledDate" />
    </div>
    <template #footer>
      <Button variant="outline" @click="open = false">Cancel</Button>
      <Button :disabled="processing" @click="submit">Settle</Button>
    </template>
  </AppDialog>
</template>
